import { useState, useEffect } from "react";

export function useQuery(query, rest = {}) {
  let [loading, setLoading] = useState(true);
  let [data, setData] = useState();
  let body = JSON.stringify({ query, ...rest });

  useEffect(() => {
    let isMountedOrLatest = true;

    fetch("https://samselikoff-recipes-backend.herokuapp.com/v1/graphql", {
      method: "POST",
      body
    })
      .then(res => res.json())
      .then(json => {
        if (isMountedOrLatest) {
          setData(json.data);
          setLoading(false);
        }
      });

    return () => {
      isMountedOrLatest = false;
    };
  }, [body]);

  return { loading, data };
}

export function runQuery(query, rest = {}) {
  let body = JSON.stringify({ query, ...rest });

  return fetch("https://samselikoff-recipes-backend.herokuapp.com/v1/graphql", {
    method: "POST",
    body
  })
    .then(res => res.json())
    .then(json => json.data);
}
